import { forwardRef } from 'react';
import PropTypes from 'prop-types';

export const ExternalChannelNode = forwardRef(({ attributes, children }, ref) => {
  return (
    <span
      ref={ref}
      {...attributes}
    >
      {children}
    </span>
  );
});

ExternalChannelNode.propTypes = {
  attributes: PropTypes.shape({}).isRequired,
  children: PropTypes.node,
};

ExternalChannelNode.defaultProps = {
  children: null,
};
